import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';
import { get } from 'lodash';
import SearchInput from 'components/base/SearchInput';
import { CommonWrapper } from 'components/company/CompanyFulltime';
import ParttimeRecruitmentCard from 'components/company/ParttimeRecruitmentCard';
import { getRecruitments } from 'libs/api/main';
import { useDataApi, usePagination } from 'libs/hooks';
import { TRecruitment } from 'modules/main';
import { TListResponse, TPagination } from 'modules/types';
import { CWindowWidth } from 'constants/base.const';
import { CMentoringFieldType } from 'constants/mentoring.const';
import { ERecruitmentCategory } from 'enums/base.enum';
import { EMentoringField } from 'enums/mentoring.enum';
import { Tabs, Col, Row, Typography, List } from 'antd';

const { TabPane } = Tabs;
const { Text, Title } = Typography;

export const ParttimeList = ({ mentoringField }: { mentoringField: EMentoringField }) => {
  const [pagination, setPagination] = usePagination(12);
  const reloadPage = (page?: Partial<TPagination>) => {
    setPagination({
      ...pagination,
      ...page,
    });
  };
  const getPromise = getRecruitments.bind(null, ERecruitmentCategory.Parttime, {
    params: {
      current: pagination.current,
      pageSize: pagination.pageSize,
      q: pagination.q,
      mentoringField: mentoringField,
    },
  });
  const [{ data, loading }, setCallback] = useDataApi<TListResponse<TRecruitment>>(getPromise, {
    contents: [],
    last: false,
  });

  useEffect(() => {
    setCallback(() => getPromise);
  }, [pagination]);

  const ListHeader = ({
    pagination,
    reloadPage,
    total,
  }: {
    pagination: TPagination;
    reloadPage: any;
    total: number;
  }) => {
    return (
      <div style={{ marginBottom: '32px', marginTop: '32px' }}>
        <Row justify='space-between' gutter={[16, 6]}>
          <Col xs={24} sm={8} md={8} lg={8} xl={8}>
            <Text strong>총 {total}개의 채용정보</Text>
          </Col>
          <Col xs={24} sm={8} md={8} lg={8} xl={8} style={{ textAlign: 'center' }}>
            <SearchInput pagination={pagination} reloadPage={reloadPage} placeHolder='검색어 입력' />
          </Col>
          <Col xs={24} sm={8} md={8} lg={8} xl={8}>
            <div style={{ float: 'right' }}>{/*<Button className="small-btn">필터</Button>*/}</div>
          </Col>
        </Row>
      </div>
    );
  };

  return (
    <div
      style={{
        maxWidth: `${CWindowWidth - 200}px`,
        margin: '10px auto',
        padding: '0px 10px',
      }}
    >
      <ListHeader pagination={pagination} reloadPage={reloadPage} total={get(data, 'total')} />
      <List
        pagination={{
          ...pagination,
          total: get(data, 'total', 0),
          position: 'bottom',
          onChange: (page) => {
            reloadPage({
              current: page,
              pageSize: pagination.pageSize,
            });
          },
        }}
        loading={loading}
        grid={{ gutter: 12, xs: 1, sm: 2, md: 3, lg: 3, xl: 4, xxl: 4 }}
        dataSource={get(data, 'contents')}
        renderItem={(item) => (
          <List.Item>
            <ParttimeRecruitmentCard data={item} />
          </List.Item>
        )}
      />
    </div>
  );
};

const CompanyParttime = () => {
  const location = useLocation();
  const [key, setKey] = useState('');
  const [fieldKey, setFieldKey] = useState('consulting');

  useEffect(() => {
    setKey(location.pathname);
  }, [location]);

  return (
    <CommonWrapper>
      <Helmet>
        <title>{CMentoringFieldType[fieldKey]} - 인턴 공고</title>
      </Helmet>
      <div className='title_wrapper'>
        <Title>인턴 공고</Title>
        <Text style={{ marginTop: '10px' }}>
          국내 최고 컨설팅 Firm에서의 인턴 경험을 통해 꿈에 한발 더 다가가세요.{' '}
        </Text>
      </div>
      <Tabs
        activeKey={fieldKey}
        onChange={(e) => {
          setFieldKey(e);
        }}
        centered={true}
      >
        <TabPane tab='Consulting' key='consulting'>
          <ParttimeList mentoringField={EMentoringField.Consulting} />
        </TabPane>
        <TabPane tab='Finance' key='finance'>
          <ParttimeList mentoringField={EMentoringField.Finance} />
        </TabPane>
        <TabPane tab='Tech' key='tech'>
          <ParttimeList mentoringField={EMentoringField.Tech} />
        </TabPane>
      </Tabs>
    </CommonWrapper>
  );
};

export default CompanyParttime;
